import { z } from 'zod';
import { TestCaseEvaluationFilterSchema } from './-table/type';

/**
 * テストセット詳細 > テスト項目タブ の URL search スキーマ。
 *
 * 当面はすべてクライアントサイド処理(評価結果タブ絞り込み / freeText 部分一致 /
 * ページング)のため、状態のみ URL に保持する。test-sets 台帳・quality-scope の
 * URL search を手本にした構成。`id`(= TestSet.id)は URL path 由来のため
 * ここでは管理しない。
 *
 * - status:    評価結果タブ用フィルタ("ALL" + 5 評価値)
 * - freeText:  検索バー(対象 / 手順 / 期待値 への部分一致)
 * - pageIndex: 0-origin ページ番号
 * - pageSize:  1 ページあたりの件数
 */
export const TestItemsListFilterSchema = z.object({
  status: TestCaseEvaluationFilterSchema.default('ALL'),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});